import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AppCTA from '../../../common/features/cta';
import '../audience.scss';
import AppImage from '../../../common/features/image';

const ContentSection = ({ text, imageSrc, reverseOrder, imageClass, highlightedText, titleText, linkTitle= '', ctalink= '', linkColor }) => {
  return (
    <Row>
      <Col md={5} sm={12} className={`${reverseOrder ? 'order-2 order-md-1' : 'order-1 order-md-2'}`}>
        <div className='audience-com-column'>
        <div className='audience-text'>
          {titleText} <span className='energy-purple'>{highlightedText}</span>
        </div>
        <div className='smallText-section-3'>
          {text}
        </div>
        {linkTitle !== '' && ( linkColor === 'purple' ? <div className='pt-3'>
            <AppCTA.WithEnergyPurple title={linkTitle} url={ctalink} width={24} height={24} alt='link' /> 
        </div> :
        <div className='pt-3'>
        <AppCTA.WithWhiteHover title={linkTitle} url={ctalink} width={24} height={24} alt='link' /> 
    </div>)
        }
        </div>
      </Col>

      <Col md={7} sm={12} className={`${reverseOrder ? 'order-1 order-md-2' : 'order-2 order-md-1'} ${imageClass}`}>
        <AppImage src={imageSrc} alt={titleText +" "+ highlightedText} title={titleText +" "+ highlightedText} className={`aud-img-style`} />
      </Col>
    </Row>
  );
};

export default ContentSection;
